import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

//import images
import Img1 from "../assets/images/features/img-1.png";

export default class FeederSpecs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pricing: [
        {
          id: 1,
          title: "Automatic Cat Feeder Cabinet",
          description:
            "Semper urna veal tempus pharetra elit habisse platea dictumst.",
          icon: "mdi-cat",
          child: [
            {
              btitle: " ",
              title:
                "Use your existing automatic feeder by placing it inside the cabinet.",
              icon: "mdi-checkbox-marked-circle text-success",
            },
            {
              btitle: " ",
              title:
                "When food is dispensed, it lands neatly in the bottom drawer, which automatically opens.",
              icon: "mdi-checkbox-marked-circle text-success",
            },
            {
              btitle: " ",
              title:
                "For extra safety, if your fur baby paws at the drawer while closing, it automatically pushes out to prevent pinched paws.",
              icon: "mdi-checkbox-marked-circle text-success",
            },
            {
              btitle: " ",
              title: "My cats approved this feeder!",
              icon: "mdi-checkbox-marked-circle text-success",
            },
          ],
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <section style={{ color: "white" }} className="section" id="pricing">
          <Container>
            <Row className="mt-5 pt-4">
              {/* Render FeederSpecs items */}
              {this.state.pricing.map((item, key) => (
                <Col lg="12" key={key}>
                  <div
                    style={{
                      padding: "35px 50px",
                      borderRadius: "20px",
                      position: "relative",
                      border: "solid rgb(255, 100, 66)",
                    }}
                    className="pricing-box mt-4 u"
                  >
                    {item.pricingTag && (
                      <div className="pricing-badge">
                        <span className="badge">Featured</span>{" "}
                      </div>
                    )}

                    <i className={"h1 mdi " + item.icon}></i>
                    {item.titlePrimary === true ? (
                      <h4 className="f-20 text-primary">{item.title}</h4>
                    ) : (
                      <h4 className="f-20">{item.title}</h4>
                    )}

                    <div className="mt-4 pt-2">
                      <p className="mb-2 f-18">Features</p>
                      {item.child.map((linkItem, linkkey) => (
                        <p className="mb-2" key={linkkey}>
                          <i
                            className={"mdi " + linkItem.icon + " f-18 mr-2"}
                          ></i>
                          <b>{linkItem.btitle}</b> {linkItem.title}
                        </p>
                      ))}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
